/** localStorage key for the guest / signed-in browser cart (DB cart is a later phase). */
export const CART_STORAGE_KEY = 'digirasa_cart';

/** Fired after the browser cart is cleared on logout so CartProvider can drop React state. */
export const DIGIRASA_CART_CLEARED_EVENT = 'digirasa-cart-cleared';

/**
 * Remove persisted cart items from the browser.
 * Callers that own React cart state should also clear that state so the
 * CartProvider write-back effect does not restore items into localStorage.
 */
export function clearStoredCart() {
  try {
    localStorage.removeItem(CART_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Clear localStorage cart and notify CartProvider (used on logout). */
export function clearStoredCartAndNotify() {
  clearStoredCart();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(DIGIRASA_CART_CLEARED_EVENT));
  }
}
